// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.eventlogger

import org.multipaz.cbor.DataItem
import org.multipaz.eventlogger.EventPresentmentIso18013AnnexA
import org.multipaz.cbor.Cbor
import kotlinx.io.bytestring.ByteString
import org.multipaz.cbor.annotation.CborSerializableGenerated
import org.multipaz.cbor.CborMap
import org.multipaz.cbor.Tstr
import org.multipaz.cbor.toDataItemDateTimeString
import org.multipaz.cbor.buildCborMap
import org.multipaz.eventlogger.EventPresentmentData
import org.multipaz.eventlogger.toDataItem
import org.multipaz.eventlogger.fromDataItem

fun EventPresentmentIso18013AnnexA.toCbor(): ByteArray {
    return Cbor.encode(toDataItem())
}

@CborSerializableGenerated(schemaId = "98Jaff_Sf2QQX9p7bJl56j5mohIF_wCZnDOFd_0DY7Y")
val EventPresentmentIso18013AnnexA_cborSchemaId = ByteString(-9, -62, 90, 125, -1, -46, 127, 100, 16, 95, -38, 123, 108, -103, 121, -22, 62, 102, -94, 18, 5, -1, 0, -103, -100, 51, -123, 119, -3, 3, 99, -74)

fun EventPresentmentIso18013AnnexA.toDataItem(): DataItem {
    val builder = CborMap.builder()
    builder.put("type", "PresentmentIso18013AnnexA")
    builder.put("identifier", Tstr(this.identifier))
    builder.put("timestamp", this.timestamp.toDataItemDateTimeString())
    val map = this.appData.let {
        buildCborMap {
            for (entry in it.entries) {
                put(Tstr(entry.key), entry.value)
            }
        }
    }
    builder.put("appData", map)
    builder.put("presentmentData", this.presentmentData.toDataItem())
    builder.put("uri", Tstr(this.uri))
    builder.put("request", this.request)
    builder.put("response", this.response)
    builder.put("sessionTranscript", this.sessionTranscript)
    val appId = this.appId
    if (appId != null) {
        builder.put("appId", Tstr(appId))
    }
    val origin = this.origin
    if (origin != null) {
        builder.put("origin", Tstr(origin))
    }
    builder.put("readerEngagement", this.readerEngagement)
    return builder.end().build()
}

fun EventPresentmentIso18013AnnexA_fromDataItem(dataItem: DataItem): EventPresentmentIso18013AnnexA {
    val identifier = dataItem["identifier"].asTstr
    val timestamp = dataItem["timestamp"].asDateTimeString
    val map0 = dataItem["appData"].let {
        buildMap<String, DataItem> {
            for (entry in it.asMap.entries) {
                put(entry.key.asTstr, entry.value)
            }
        }
    }
    val appData = map0
    val presentmentData = EventPresentmentData.fromDataItem(dataItem["presentmentData"])
    val uri = dataItem["uri"].asTstr
    val request = dataItem["request"]
    val response = dataItem["response"]
    val sessionTranscript = dataItem["sessionTranscript"]
    val appId0 = if (dataItem.hasKey("appId")) {
        dataItem["appId"].asTstr
    } else {
        null
    }
    val origin0 = if (dataItem.hasKey("origin")) {
        dataItem["origin"].asTstr
    } else {
        null
    }
    val readerEngagement = dataItem["readerEngagement"]
    return EventPresentmentIso18013AnnexA(
        identifier = identifier,
        timestamp = timestamp,
        appData = appData,
        presentmentData = presentmentData,
        uri = uri,
        request = request,
        response = response,
        sessionTranscript = sessionTranscript,
        appId = appId0,
        origin = origin0,
        readerEngagement = readerEngagement,
    )
}
